import styled, { css } from "styled-components";
import { typographyCSS } from "@ifgengineering/design-tokens/legacy";

export type V3SegmentedControlSize = "sm" | "md";

export const Track = styled.div<{ $fullWidth: boolean }>`
  display: ${({ $fullWidth }) => ($fullWidth ? "flex" : "inline-flex")};
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "auto")};
  align-items: stretch;
  gap: ${({ theme }) => theme.space["3xs"]}px;
  padding: ${({ theme }) => theme.space["2xs"]}px;
  border-radius: ${({ theme }) => theme.radius.full}px;
  background: ${({ theme }) => theme.colors.ui.background.inset};
`;

export const Segment = styled.button<{
  $selected: boolean;
  $size: V3SegmentedControlSize;
  $fullWidth: boolean;
}>`
  ${typographyCSS("label.sm-semibold")}
  flex: ${({ $fullWidth }) => ($fullWidth ? "1 1 0" : "none")};
  border: none;
  cursor: pointer;
  white-space: nowrap;
  border-radius: ${({ theme }) => theme.radius.full}px;
  background: transparent;
  color: ${({ theme }) => theme.colors.ui.text.secondary};

  padding: ${({ theme, $size }) =>
      $size === "sm" ? theme.space["2xs"] : theme.space.sm}px
    ${({ theme, $size }) =>
      $size === "sm" ? theme.space.md : theme.space.card.inset}px;

  ${({ theme, $selected }) =>
    $selected &&
    css`
      background: ${theme.colors.ui.background.segmentSelected};
      color: ${theme.colors.ui.text.onFill};
      box-shadow: ${theme.elevation.low};
    `}

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.ui.interactive.disabledText};
  }

  &:focus-visible {
    outline: ${({ theme }) => theme.stroke.focus}px solid
      ${({ theme }) => theme.colors.ui.border.focus};
    outline-offset: ${({ theme }) => theme.stroke.focus}px;
  }
`;
